import ApplicationUserApiClient from "@/api/applicationUserApiClient";
import { AppUser } from "@/contexts/UserContext/types";
import { useAuthenticatedApiClient } from "./useAuthenticatedApiClient";

export const useApplicationUserApiClient = () => {
  const applicationUserApiClient = useAuthenticatedApiClient(ApplicationUserApiClient);

  return {
    // Login methods that require explicit access tokens
    loginConsumer: (accessToken: string): Promise<AppUser> => {
      return applicationUserApiClient.loginConsumer(accessToken);
    },
    loginBanker: (accessToken: string): Promise<AppUser> => {
      return applicationUserApiClient.loginBanker(accessToken);
    },
    // Permission methods that require explicit access tokens
    checkPermission: (
      userId: string,
      actionName: string,
      resourceName: string | undefined,
      accessToken: string
    ): Promise<boolean> => {
      return applicationUserApiClient.checkPermission(
        userId,
        actionName,
        resourceName,
        accessToken
      );
    },
    checkPermissions: (
      userId: string,
      requiredPermissions: {
        actionName: string;
        resourceName?: string;
      }[],
      accessToken: string
    ): Promise<
      {
        actionName: string;
        resourceName?: string;
        hasPermission: boolean;
      }[]
    > => {
      return applicationUserApiClient.checkPermissions(userId, requiredPermissions, accessToken);
    },
  };
};
